KROWN.themeName = 'Split';
KROWN.themeVersion = '4.0.0';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-popup') ) {
    const newsletterPopup = document.getElementById('modal-popup');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

document.addEventListener('DOMContentLoaded', function() {
  // Function to log the number of reviews and disconnect the observer
  function logReviewCount(observer) {
    const reviews = document.querySelectorAll('#klaviyo-reviews-all .kl_reviews__review_item');
    console.log('Number of reviews:', reviews.length);
    if (reviews.length > 0) {
      observer.disconnect(); 
      manageReviewsDisplay(reviews);
    }
  }

  // Function to observe the entire document for additions of review items
  function observeForReviewItems() {
    const observer = new MutationObserver(() => {
      logReviewCount(observer);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Initial check in case reviews are already present
    logReviewCount(observer);
  }

  // Function to manage the display of reviews and add the toggle button
  function manageReviewsDisplay(reviews) {
    const container = document.querySelector('#klaviyo-reviews-all .kl_reviews__list_container');
    if (!container) {
      console.error('Reviews container not found');
      return;
    }

    // Hide reviews beyond the first 1
    reviews.forEach((review, index) => {
      if (index >= 1) {
        review.style.display = 'none';
      }
    });

    // Create the "View More" button
    const toggleButton = document.createElement('button');
    toggleButton.textContent = 'View More';
    toggleButton.classList.add('view-more-reviews');
    toggleButton.style.display = 'block';
    toggleButton.style.margin = '10px 0';

    // Add event listener to the button
    toggleButton.addEventListener('click', () => {
      const isHidden = reviews[4].style.display === 'none';
      reviews.forEach((review, index) => {
        if (index >= 1) {
          review.style.display = isHidden ? 'block' : 'none';
        }
      });
      toggleButton.textContent = isHidden ? 'View Less' : 'View More';
    });

    // Append the button to the container
    container.appendChild(toggleButton);
  }

  // Check if reviews are already present on page load
  setTimeout(() => {
    const reviewsPresent = document.querySelectorAll('#klaviyo-reviews-all .kl_reviews__review_item').length > 0;
    if (!reviewsPresent) {
      observeForReviewItems();
    } else {
      const reviews = document.querySelectorAll('#klaviyo-reviews-all .kl_reviews__review_item');
      manageReviewsDisplay(reviews);
    }
  }, 1000); // Adjust the timeout as necessary
});




